import React from 'react';
import AppScrollArea from '../components/common/AppScrollArea';
import Background from '../components/common/Background';
import beachMp4 from '../assets/video/beach.mp4';
import beachWebm from '../assets/video/beach.webm';
import beachImage from '../assets/video/beach.jpg';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

const AuthCardLayout = () => {
	return (
		<Container fluid className='position-relative app-auth-layout'>
			<Background video={[beachMp4, beachWebm]} image={beachImage} overlay='2' className='rounded-soft' />
			<AppScrollArea className='app-auth-scroll' maxHeight='100dvh' fillViewport highlightOnScroll style={{ minHeight: '100dvh' }}>
				<Outlet />
			</AppScrollArea>
		</Container>
	);
};

export default AuthCardLayout;
